import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

import { WithBannerUserStatus, useAuth, UserStatus, UserStatuses, PaymentMethod } from "@/features/auth";
import { getDaysLeft } from "@/utils";

const messageKeys: {
  [key in UserStatus]: key extends WithBannerUserStatus ? string : null;
} = {
  [UserStatuses.Trial]: "navigation.subscription_trial_description",
  [UserStatuses.Inactive]: "navigation.subscription_inactive_description",
  [UserStatuses.Expiring]: "navigation.subscription_expiring_description",
  [UserStatuses.WaitingForPayment]: "navigation.subscription_waiting_for_payment_description",
  [UserStatuses.Active]: null,
};

const getMessageKey = (paymentMethod: PaymentMethod, status: UserStatus, daysLeft: number) => {
  if (paymentMethod === PaymentMethod.Free) return "";

  if (status === UserStatuses.Trial && daysLeft < 0) return messageKeys[UserStatuses.Expiring];

  return messageKeys[status];
};

const TrialSubscription = () => {
  const { t } = useTranslation("coi-platform-translations");
  const { user, accountDetails } = useAuth();

  if (!user || !accountDetails) return null;

  const { payment_method: paymentMethod, status, trial_or_active_period_ends: trialEnds } = user;

  const daysLeft = getDaysLeft(trialEnds || "");

  const messageKey = getMessageKey(paymentMethod, status, daysLeft);

  if (messageKey === null) return null;

  const isInTrial = status === UserStatuses.Trial;

  return (
    <Typography
      variant="body1"
      color={isInTrial ? "primary" : "error"}
      sx={{ a: { color: "inherit" } }}
      data-testid={`trial-subscription-message-${status}`}
    >
      {parse(t(messageKey, { count: daysLeft }))}
    </Typography>
  );
};

export default TrialSubscription;
